(function () {
  'use strict';

  var ACTIVE = 'is-active';
  var VISIBLE = 'is-visible';

  function closeItem(btn, content) {
    btn.setAttribute('aria-expanded', 'false');
    if (!content) return;
    content.classList.remove(VISIBLE);
    window.setTimeout(function () {
      content.classList.remove(ACTIVE);
    }, 300);
  }

  function openItem(btn, content) {
    btn.setAttribute('aria-expanded', 'true');
    if (!content) return;
    content.classList.add(ACTIVE);
    window.requestAnimationFrame(function () {
      content.classList.add(VISIBLE);
    });
  }

  function initFaqs(root) {
    if (!root || root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    var singleOpen = root.dataset.singleOpen === 'true';

    root.querySelectorAll('.js-accordion-btn').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.stopImmediatePropagation();

        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var content = document.getElementById(btn.getAttribute('aria-controls'));

        if (singleOpen && !expanded) {
          root.querySelectorAll('.js-accordion-btn').forEach(function (other) {
            if (other === btn) return;
            if (other.getAttribute('aria-expanded') !== 'true') return;
            closeItem(other, document.getElementById(other.getAttribute('aria-controls')));
          });
        }

        if (expanded) closeItem(btn, content);
        else openItem(btn, content);
      });

      btn.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var content = document.getElementById(btn.getAttribute('aria-controls'));
        if (btn.getAttribute('aria-expanded') !== 'true') return;
        event.stopImmediatePropagation();
        closeItem(btn, content);
        btn.focus();
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-faq]').forEach(initFaqs);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
